// extracted by mini-css-extract-plugin
export default {"dialog":"dialog_dialog__fpf83","overlay":"dialog_overlay__xkAz9","dialog_content":"dialog_dialog_content__KcmRM"};